

// import postApiNewsMutator from './mutator/customInstance';
import type { ErrorType as PostApiNewsErrorType } from './mutator/customInstance';
import { NewsCommand } from './models/newsCommand';
// import { BooleanValueResult } from './models';
import { MutationFunction, UseMutationOptions, UseMutationResult, useMutation } from 'react-query';
import { News } from '../models/news.model';


// Mock function to fetch news list
const fetchNewsList = async (newsCommand?: NewsCommand): Promise<News[]> => {
    
    // Mocked news data
    const mockedNews: News[] = []

;
    // Simulate API response delay (remove when API is ready to implement)
    await new Promise(resolve => setTimeout(resolve, 1000));

    const newById = newsCommand?.id ? mockedNews.find((item) => String(item?.id) === newsCommand.id) : null

    return newById ? [newById] : mockedNews;
    /*return postApiNewsMutator<BooleanValueResult>(
        {
            url: `/api/News`, method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            data: newsCommand
        },
    );*/
};


export const getNewsListMutationOptions = <TError = PostApiNewsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof fetchNewsList>>, TError, { data?: NewsCommand }, TContext>, }
    ): UseMutationOptions<Awaited<ReturnType<typeof fetchNewsList>>, TError, { data?: NewsCommand }, TContext> => {
    const { ...rest } = options ?? {};

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof fetchNewsList>>, { data?: NewsCommand }> = (props) => {
        // Call the fetch function to get news list
        return fetchNewsList(props.data);
    };

    return { mutationFn, ...rest };
};

export const useGetApiNews = <TError = PostApiNewsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof fetchNewsList>>, TError, { data?: NewsCommand }, TContext>, }
    ): UseMutationResult<
        Awaited<ReturnType<typeof fetchNewsList>>,
        TError,
        { data?: NewsCommand },
        TContext
    > => {
    const mutationOptions = getNewsListMutationOptions(options);

    return useMutation(mutationOptions);
};